angular.module('unergie.main')
.filter('counterFilter', () =>
    function (val) {
        switch (val) {
            case 'CBE': return 'Compteur Électronique (CBE)'
            case 'CFB':
            case 'EMC': return 'Électromécanique (EMC)'
            case 'AMM': return 'Linky (AMM)'
            default: return val
        }
    },
)
